import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../const";
import _ from 'lodash';
import { unAuthorized } from '../../../../auth/Auth.ducks'
import { Service } from "../../../../service/service"
// Histoevent actions

export const GET_HISTOEVENT_PENDING = "GET_HISTOEVENT_PENDING";
export const GET_HISTOEVENT_REJECTED = "GET_HISTOEVENT_REJECTED";
export const GET_HISTOEVENT_FULFILLED = "GET_HISTOEVENT_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case GET_HISTOEVENT_PENDING:
      return true;
    case GET_HISTOEVENT_REJECTED:
    case GET_HISTOEVENT_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_HISTOEVENT_PENDING:
    case GET_HISTOEVENT_FULFILLED:
      return null;
    case GET_HISTOEVENT_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_HISTOEVENT_FULFILLED:
      return _.isEmpty(payload.data) ? [] : payload.data.historique;
    default:
      return state;
  }
};

// HISTOEVENT reducer
export default combineReducers({ loading, error, data });

export const getHistoEventSimple = (tok, id) => {
  return (dispatch) => {
    dispatch({ type: GET_HISTOEVENT_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants/${id}/historiques`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_HISTOEVENT_FULFILLED, payload: res })
    })
    response.catch(err => {let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_HISTOEVENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}